export default __webpack_public_path__ + "24343d7fadb07aef800d533b3b51d144.svg";